import axios from "axios";

export const GlobalRankingService = () => {

    const getFightPowerRanking = async (paginated, limit) => {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}v1/ranking/global/byFightPower?limit=${limit}&paginated=${paginated}`);
        return response.data.data;
    };

    return {
        getFightPowerRanking
    };
};